module.exports = __webpack_public_path__ + "media/images/sms_registry_campaign-004b9985114cf5d004ed091d7c0b4fdf.svg";